var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_211_820)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9858 13.9614L4 23.8468C5.99734 25.8241 8.27899 27.4905 10.7666 28.7942C11.4542 30.5998 12.532 32.2931 14 33.7463C19.5229 39.2136 28.4772 39.2136 34 33.7463C35.468 32.2931 36.5458 30.5998 37.2334 28.7941C39.721 27.4905 42.0027 25.8241 44 23.8468L34.0223 13.9695C34.0149 13.9621 34.0075 13.9547 34 13.9473C28.4772 8.47997 19.5229 8.47997 14 13.9473C13.9953 13.952 13.9905 13.9567 13.9858 13.9614ZM33.0445 30.5777C30.1345 31.5499 27.0797 32.0478 24 32.0478C20.9203 32.0478 17.8656 31.5499 14.9556 30.5777C15.2709 30.9918 15.619 31.3892 16 31.7664C20.4183 36.1403 27.5817 36.1403 32 31.7664C32.381 31.3892 32.7292 30.9918 33.0445 30.5777ZM16.2051 15.7292C16.9554 16.2199 17.7532 16.6398 18.588 16.9822C20.3038 17.6857 22.1428 18.0478 24 18.0478C25.8572 18.0478 27.6962 17.6857 29.412 16.9822C30.2468 16.6398 31.0446 16.2199 31.795 15.7292C27.4318 11.6193 20.5682 11.6193 16.2051 15.7292Z",
    fill: "#3B4158"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_211_820"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 28,
    fill: "white",
    transform: "translate(4 9.8468)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/Logo2.d3087bba65b056636c2acccf16da1f0a.svg";
export { ForwardRef as ReactComponent };